<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" epub:type="dedication" id="dedication">
<h1 class="hidden" data-number="1" epub:type="dedication">Dedication</h1>
<p>Ann, without whom this simply would not happen.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?8c7c0192